var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5667 17.4739L13.1498 11.0569C12.5721 10.4792 12.5721 9.54224 13.1498 8.96449L19.5233 2.59088C20.1011 2.01314 20.1011 1.07618 19.5233 0.498099L19.5025 0.47727C18.9244 -0.100815 17.9875 -0.100815 17.4098 0.47727L11.0363 6.85088C10.4582 7.42863 9.52124 7.42863 8.94351 6.85088L2.5263 0.433563C1.94823 -0.144521 1.01129 -0.144521 0.433556 0.433563C-0.144519 1.01131 -0.144519 1.94826 0.433556 2.52635L6.85111 8.94332C7.42884 9.52106 7.42884 10.4584 6.85111 11.0361L0.477262 17.4101C-0.100813 17.9878 -0.100813 18.9248 0.477262 19.5025L0.49809 19.5237C1.07616 20.1014 2.01276 20.1014 2.59049 19.5237L8.96468 13.1497C9.54276 12.572 10.4794 12.572 11.0571 13.1497L17.4743 19.5667C18.052 20.1444 18.989 20.1444 19.5667 19.5667C20.1444 18.9889 20.1444 18.0517 19.5667 17.4739Z",
    fill: "#24272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.8e634a25c778f15b706a0cf961b7e82f.svg";
export { ForwardRef as ReactComponent };